/*!
 * Copyright © 2026. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum EOverrideStatus {
  ACTIVE = 'Active',
  PLANNED = 'Planned',
  EXPIRED = 'Expired',
  NONE = 'None'
}
